import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Ofertas',
  create: 'Nova oferta',
  loadError: 'Não foi possível carregar as ofertas',
  footnote:
    'Aprovar não põe a oferta no ar: a Bodyprint cria a campanha com o público, os lugares no app e o período.',
} satisfies TranslationTree;
